import { toArray } from 'rxjs/operators';

export enum EnumEtats {
    ATRAITER = 'A TRAITER',
    ENCOURS = 'EN COURS',
    TRAITEE = 'TRAITEE',
    REJETEE = 'REJETEE'
}